import { Application } from './Application';
import { IApplication } from './IAplication';

export function app(): IApplication {
  return Application.instance;
}
